import dash_api from '../../support/dash_api';
import NotificationActions from '../NotificationActions';
import { ReduxAsyncAction } from '../../support/utils';
import {
  DashboardPostbackIndexMapping,
  DashboardConversionValueMapping,
} from '../../../../../shared/types/skadNetwork.types';

const GetPostbacksConversionValueMapping = new ReduxAsyncAction('GET_POSTBACKS_CONVERSION_VALUE_MAPPING');
GetPostbacksConversionValueMapping.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/skadnetworkv2/conversion-value-mapping');

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get Conversion Value Mapping. Please try again.', 'error');

    throw error;
  }
});
export const GET_POSTBACKS_CONVERSION_VALUE_MAPPING: any = GetPostbacksConversionValueMapping.constants;
export const getPostbacksConversionValueMapping = GetPostbacksConversionValueMapping.request;

const UpdateConversionValueMapping = new ReduxAsyncAction('UPDATE_CONVERSION_VALUE_MAPPING');
UpdateConversionValueMapping.registerRequest(
  async (
    postbackIndexMapping: DashboardPostbackIndexMapping,
    conversionValueMapping: DashboardConversionValueMapping,
    ascendingOnly: boolean,
    targetEvent?: string,
    skadnetworkRecommendationRevisionId?: string
  ) => {
    try {
      const response = await dash_api.put('/v1/skadnetworkv2/conversion-value-mapping', {
        postbackIndexMapping: postbackIndexMapping,
        conversionValueMapping: conversionValueMapping,
        ascendingOnly: ascendingOnly,
        targetEvent: targetEvent,
        skadnetworkRecommendationRevisionId: skadnetworkRecommendationRevisionId,
      });

      return response.data;
    } catch (error) {
      NotificationActions.showNotification('Cannot update Conversion Value Mapping. Please try again.', 'error');

      throw error;
    }
  }
);
export const UPDATE_CONVERSION_VALUE_MAPPING: any = UpdateConversionValueMapping.constants;
export const updateConversionValueMapping = UpdateConversionValueMapping.request;

const GetSkAdNetworkApplicationStatus = new ReduxAsyncAction('GET_SK_AD_NETWORK_APPLICATION_STATUS');
GetSkAdNetworkApplicationStatus.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/skadnetworkv2/skan-app-status');

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get Sk Ad Network Application status. Please try again.', 'error');

    throw error;
  }
});
export const GET_SK_AD_NETWORK_APPLICATION_STATUS: any = GetSkAdNetworkApplicationStatus.constants;
export const getSkAdNetworkApplicationStatus = GetSkAdNetworkApplicationStatus.request;

const UpdateSkAdNetworkApplicationStatus = new ReduxAsyncAction('UPDATE_SK_AD_NETWORK_APPLICATION_STATUS');
UpdateSkAdNetworkApplicationStatus.registerRequest(async (skAdNetworkEnabled: boolean) => {
  try {
    const response = await dash_api.put('/v1/skadnetworkv2/skan-app-status', { skAdNetworkEnabled });

    NotificationActions.showNotification(
      `We have confirmed your SK Ad Network opt-${skAdNetworkEnabled ? 'in' : 'out'}.`,
      'success'
    );

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot update Sk Ad Network Application status. Please try again.', 'error');

    throw error;
  }
});
export const UPDATE_SK_AD_NETWORK_APPLICATION_STATUS: any = UpdateSkAdNetworkApplicationStatus.constants;
export const updateSkAdNetworkApplicationStatus = UpdateSkAdNetworkApplicationStatus.request;

const GetTargetEventsRecommendations = new ReduxAsyncAction('GET_TARGET_EVENTS_RECOMMENDATIONS');
GetTargetEventsRecommendations.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/skadnetworkv2/recommendations/target-events');

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get target events recommendations. Please try again.', 'error');

    throw error;
  }
});
export const GET_TARGET_EVENTS_RECOMMENDATIONS: any = GetTargetEventsRecommendations.constants;
export const getTargetEventsRecommendations = GetTargetEventsRecommendations.request;

const GetConversionValueMappingRecommendation = new ReduxAsyncAction('GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION');
GetConversionValueMappingRecommendation.registerRequest(async (targetEvent: string) => {
  try {
    const response = await dash_api.get(`/v1/skadnetworkv2/recommendations/mapping/${targetEvent}`);

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get conversion value mapping recommendation. Please try again.', 'error');

    throw error;
  }
});
export const GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION: any = GetConversionValueMappingRecommendation.constants;
export const getConversionValueMappingRecommendation = GetConversionValueMappingRecommendation.request;

const SetCurrentTargetEvent = new ReduxAsyncAction('SET_CURRENT_TARGET_EVENT');
SetCurrentTargetEvent.registerRequest(async (targetEvent: string) => {
  return targetEvent;
});
export const SET_CURRENT_TARGET_EVENT: any = SetCurrentTargetEvent.constants;
export const setCurrentTargetEvent = SetCurrentTargetEvent.request;

const SetCurrentConversionValueMapping = new ReduxAsyncAction('SET_CURRENT_CONVERSION_VALUE_MAPPING');
SetCurrentConversionValueMapping.registerRequest(async (mapping: DashboardConversionValueMapping) => {
  return mapping;
});
export const SET_CURRENT_CONVERSION_VALUE_MAPPING: any = SetCurrentConversionValueMapping.constants;
export const setCurrentConversionValueMapping = SetCurrentConversionValueMapping.request;

const SetAscendingOnly = new ReduxAsyncAction('SET_ASCENDING_ONLY');
SetAscendingOnly.registerRequest(async (ascendingOnly?: boolean) => {
  return ascendingOnly;
});
export const SET_ASCENDING_ONLY: any = SetAscendingOnly.constants;
export const setAscendingOnly = SetAscendingOnly.request;

const GetMappingTemplatesOptions = new ReduxAsyncAction('GET_MAPPING_TEMPLATES_OPTIONS');
GetMappingTemplatesOptions.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/skadnetworkv2/templates/titles');

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get mapping templates. Please try again.', 'error');

    throw error;
  }
});
export const GET_MAPPING_TEMPLATES_OPTIONS: any = GetMappingTemplatesOptions.constants;
export const getMappingTemplatesOptions = GetMappingTemplatesOptions.request;

const GetMappingTemplate = new ReduxAsyncAction('GET_MAPPING_TEMPLATE');
GetMappingTemplate.registerRequest(async (id: string) => {
  try {
    const response = await dash_api.get(`/v1/skadnetworkv2/templates/${id}`);

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get mapping template. Please try again.', 'error');

    throw error;
  }
});
export const GET_MAPPING_TEMPLATE: any = GetMappingTemplate.constants;
export const getMappingTemplate = GetMappingTemplate.request;
